var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClickClap(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-0.5 0 24 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 3 Copy"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 139",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0221 6.01467C18.0221 6.01467 16.1526 4.45535 15.1601 2.99422C14.7898 2.44965 13.5899 2.51809 13.1781 3.5626L6.70152 6.07121L2.43222 3.75603C1.75672 3.3543 0.894567 3.63997 0.509412 4.40773L0.503486 4.41964C0.115369 5.18442 0.352387 6.12775 1.02789 6.53246L1.68562 6.92527C1.11085 6.82112 0.500524 7.12167 0.1924 7.72874L0.189437 7.74064C-0.201644 8.50542 0.0324121 9.45173 0.710878 9.85347L2.18632 10.7403C1.50785 10.3385 0.64866 10.6272 0.266468 11.386L0.260542 11.4039C-0.130538 12.1716 0.10648 13.112 0.781983 13.5197C0.781983 13.5197 8.29251 18.1679 10.876 19.5754C12.9262 20.6795 16.9407 21.2211 19.4709 18.153C20.4012 17.0252 18.0221 6.01467 18.0221 6.01467Z",
    fill: "#F8AC3B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 140",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1449 5.98783C19.8058 5.07128 18.911 3.86608 18.2385 2.03C18.0074 1.39616 17.083 1.29796 16.5527 2.32759C15.7824 3.80359 16.5231 5.02069 16.926 5.55336L17.1216 5.80631C17.1216 5.80631 17.2371 6.26161 17.4593 6.82106C16.3542 6.56514 15.0921 7.19304 14.2062 8.36551C13.2967 9.57666 11.1368 11.6657 10.2273 12.8798C9.12218 14.3409 9.41549 16.43 10.651 17.3316C10.651 17.3316 17.1512 22.1048 21.4797 16.2544C24.8721 11.6776 22.493 6.91629 21.1449 5.98783Z",
    fill: "#FAD06B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 141",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9494 7.74961C19.6131 8.23169 19.7642 9.22264 19.2902 9.96361L19.2842 9.97254C18.8043 10.7135 17.8918 10.9248 17.2251 10.4427L6.89706 2.94963C6.2334 2.46755 6.0823 1.47958 6.55634 0.738599L6.56819 0.729672C7.03927 -0.0113049 7.95771 -0.222587 8.62137 0.256518L18.9494 7.74961Z",
    fill: "#FAD06B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 142",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6046 6.92533L7.00655 2.14023C6.6451 1.88431 6.3903 1.48555 6.494 0.842773C6.01996 1.67302 6.31031 2.52411 6.891 2.94072L13.486 7.7288C14.1497 8.2079 14.2623 7.40444 13.6046 6.92533Z",
    fill: "#E3A95D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 143",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5751 9.18984C16.2358 9.66895 16.3869 10.6569 15.9158 11.3979L15.9069 11.4128C15.4329 12.1508 14.5144 12.3621 13.8508 11.8829L3.52564 4.38986C2.85903 3.91075 2.702 2.92278 3.179 2.18181L3.19085 2.16693C3.66193 1.42893 4.58333 1.22062 5.24699 1.69675L15.5751 9.18984Z",
    fill: "#FAD06B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 144",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6049 9.35661L3.63215 3.58056C3.2707 3.31572 3.01591 2.84554 3.11368 2.28906C2.64853 3.12527 2.8974 4.03289 3.47809 4.45248L11.4864 10.1631C12.147 10.6451 12.2656 9.84465 11.6049 9.35661Z",
    fill: "#E3A95D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 145",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9291 12.5526C15.5898 13.0317 15.7439 14.0227 15.2698 14.7607L15.2609 14.7726C14.7869 15.5136 13.8655 15.7189 13.2018 15.2398L2.87672 7.74967C2.21307 7.27056 2.06197 6.28259 2.53305 5.54459L2.54194 5.52674C3.01597 4.79171 3.93738 4.58043 4.59807 5.05954L14.9291 12.5526Z",
    fill: "#FAD06B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 146",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0166 12.0411L2.98307 6.94058C2.62458 6.67871 2.35793 6.1133 2.53273 5.54492C1.98463 6.31863 2.20979 7.37802 2.78753 7.80059L9.90401 12.8476C10.5647 13.3267 10.6802 12.5262 10.0166 12.0411Z",
    fill: "#E3A95D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 147",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6534 16.2906C15.3141 16.7697 10.5737 17.2726 9.913 16.7964L2.60394 11.4995C1.93733 11.0115 1.78326 10.0235 2.2573 9.2855L2.26619 9.2736C2.74023 8.52965 3.66164 8.32134 4.32232 8.80342L14.6534 16.2906Z",
    fill: "#FAD06B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 148",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1893 11.9367C23.1893 11.9367 22.4635 15.6059 19.5866 17.802C17.015 19.7631 13.0301 18.0579 11.1369 16.7962C9.13116 15.4571 8.10902 14.7697 3.32125 11.1154C2.41761 10.425 2.16282 9.93397 2.30503 9.2168C1.60286 9.98456 1.95543 11.1273 2.53316 11.5409L3.0309 11.895C3.0309 11.895 8.78749 16.1266 10.7399 17.4925C12.4998 18.7215 17.1187 20.7034 20.0459 18.3674C23.3078 15.7666 23.1893 11.9367 23.1893 11.9367Z",
    fill: "#E3A95D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 149",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2382 7.18094C17.3968 6.30308 17.3671 5.03836 17.3671 5.03836L17.1775 4.78244C16.8486 4.36285 16.3183 3.51177 16.4961 2.4375C15.708 3.88374 16.4753 5.04431 16.8753 5.56508L17.0738 5.82695C17.0738 5.82695 17.0383 6.19595 17.2249 6.49651L18.2382 7.18094Z",
    fill: "#E3A95D"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClickClap);
export default __webpack_public_path__ + "static/media/clickClap.2d1ba7cea7297c050f83d4b1324fcaf6.svg";
export { ForwardRef as ReactComponent };